import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RouterModule, NoPreloading, Routes } from '@angular/router';

import { AuthorizationService } from '../services/authorization.service';
import { OAuthModule } from 'angular-oauth2-oidc';
import { AppRoutingModule } from './app-routing.module';
import { AppInsightsService } from '../services/app-insights.service';
import { IdentityService } from '../services/identity.service';
import { LegalAdGuard } from '../guards/legal-ad.guard';
import { LoadingIndicatorService } from '../services/loading-indicator.service';
import { LoadingIndicatorInterceptor } from '../services/loading-indicator.interceptor';
import { LegalAdService } from '../services/legal-ad.service';
import { DataHandlerService } from '../services/data-handler.service';

import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { CalendarModule } from 'primeng/calendar';
import { FileUploadModule } from 'primeng/fileupload';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { TableModule } from 'primeng/table';
import { MultiSelectModule } from 'primeng/multiselect';

import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { FormAssistanceComponent } from './form-assistance/form-assistance.component';
import { LegalAdFormComponent } from './legal-ad-form/legal-ad-form.component';
import { NavTopComponent } from './nav-top/nav-top.component';

import { OptionNotNegDirective } from '../directives/OptionNotNegDirective';
import { FocusFirstInvalidFieldDirective } from '../directives/FocusFirstInvalidFieldDirective';

import { FormatRequestStatusPipe } from '../pipes/FormatRequestStatusPipe';
import { FormRequestApprovalsPipe } from '../pipes/FormRequestApprovalsPipe';
import { FormRequestSubmittedPipe } from '../pipes/FormRequestSubmittedPipe';
import { FilterCompletedApprovalsPipe } from '../pipes/FilterCompletedApprovalsPipe';
import { SortByDateApprovedPipe } from '../pipes/SortByDateApprovedPipe';
import { environment } from 'src/environments/environment';

const appRoutes: Routes = [
    { path: '', redirectTo: '/home', pathMatch: 'full' },
    { path: 'home', component: HomeComponent },
    { path: 'form', component: LegalAdFormComponent, canActivate: [LegalAdGuard] },
    { path: 'form/:id', component: LegalAdFormComponent, canActivate: [LegalAdGuard] }
];

@NgModule({
    declarations: [
        AppComponent,
        HomeComponent,
        FormAssistanceComponent,
        LegalAdFormComponent,
        NavTopComponent,
        OptionNotNegDirective,
        FocusFirstInvalidFieldDirective,
        FormatRequestStatusPipe,
        FormRequestApprovalsPipe,
        FormRequestSubmittedPipe,
        FilterCompletedApprovalsPipe,
        SortByDateApprovedPipe
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        ReactiveFormsModule,
        FormsModule,
        BrowserAnimationsModule,
        NgMultiSelectDropDownModule.forRoot(),
        MultiSelectModule,
        CalendarModule,
        FileUploadModule,
        ToastModule,
        TableModule,
        OAuthModule.forRoot({
            resourceServer: {
                allowedUrls: [environment.apiUrl],
                sendAccessToken: true
            }
        }),
        RouterModule.forRoot(appRoutes, { preloadingStrategy: NoPreloading, scrollPositionRestoration: 'enabled' })], providers: [
            AppInsightsService,
            AuthorizationService,
            IdentityService,
            LoadingIndicatorService,
            {
                provide: HTTP_INTERCEPTORS,
                useClass: LoadingIndicatorInterceptor,
                multi: true,
            },
            LegalAdService,
            DataHandlerService,
            [MessageService],
            provideHttpClient(withInterceptorsFromDi())
        ]
})
export class AppModule { }





